import { useCallback, useEffect } from 'react';
export var createDeferHandler = function (callback, timeout) {
    if (timeout === void 0) { timeout = 250; }
    var timeoutId;
    var deferredCallback = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var synteticEvent = args[0];
        (_a = synteticEvent === null || synteticEvent === void 0 ? void 0 : synteticEvent.persist) === null || _a === void 0 ? void 0 : _a.call(synteticEvent);
        timeoutId = window.setTimeout(function () { return callback.apply(void 0, args); }, timeout);
    };
    deferredCallback.cancel = function () {
        clearTimeout(timeoutId);
    };
    return deferredCallback;
};
export var useDeferCallback = function (callback, deps, timeout) {
    var deferredCallback = useCallback(createDeferHandler(callback, timeout), deps);
    useEffect(function () {
        return function () {
            deferredCallback.cancel();
        };
    }, [deferredCallback]);
    return deferredCallback;
};
export var cancelDeferHandlerAfterDestroy = function (store) {
    var getState = store.getState;
    return function (next) { return function (action) {
        if (action.type.match(/redux-form\/(CHANGE|BLUR)/) &&
            !getState().form[action.meta.form]) {
            return;
        }
        return next(action);
    }; };
};
